import { getTableLength } from '@loaders.gl/schema';
import { detectGeometryColumnIndex } from "../encoder-utils/encode-utils.js";
import { encodeTableRow } from "../encoder-utils/encode-table-row.js";
import { Utf8ArrayBufferEncoder } from "../encoder-utils/utf8-encoder.js";
export function encodeTableAsGeojsonInBatches(batchIterator) {
  try {
    let inputOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return async function* () {
      const options = {
        geojson: {},
        chunkSize: 10000,
        ...inputOpts
      };
      const utf8Encoder = new Utf8ArrayBufferEncoder(options.chunkSize);
      if (!options.geojson.featureArray) {
        utf8Encoder.push('{\n', '"type": "FeatureCollection",\n', '"features":\n');
      }
      utf8Encoder.push('[');
      let geometryColumn = options.geojson.geometryColumn;
      let isFirstLine = true;
      let start = 0;
      for await (const tableBatch of batchIterator) {
        const end = start + getTableLength(tableBatch);
        if (!geometryColumn) {
          geometryColumn = geometryColumn || detectGeometryColumnIndex(tableBatch);
        }
        for (let rowIndex = start; rowIndex < end; ++rowIndex) {
          if (!isFirstLine) {
            utf8Encoder.push(',');
          }
          utf8Encoder.push('\n');
          isFirstLine = false;
          encodeTableRow(tableBatch, rowIndex, geometryColumn, utf8Encoder);
          if (utf8Encoder.isFull()) {
            yield utf8Encoder.getArrayBufferBatch();
          }
          start = end;
        }
        const arrayBufferBatch = utf8Encoder.getArrayBufferBatch();
        if (arrayBufferBatch.byteLength > 0) {
          yield arrayBufferBatch;
        }
      }
      utf8Encoder.push('\n');
      utf8Encoder.push(']\n');
      if (!options.geojson.featureArray) {
        utf8Encoder.push('}');
      }
      yield utf8Encoder.getArrayBufferBatch();
    }();
  } catch (e) {
    return Promise.reject(e);
  }
}
//# sourceMappingURL=geojson-encoder.js.map